<template>
  <div class="col-xs-12">
    <div
      v-click-outside="clickOutside"
      :class="{ skeleton: loading }"
      class="dialog collapsed note"
      @mouseover="mouseHover = true"
      @mouseout="mouseHover = false"
    >
      <a
        v-if="isDeletable"
        class="delete-button"
        href="#"
        style="z-index: 99999"
        @click="deleting = true"
      >
        <i
          v-show="mouseHover && !deleting && !titleSelected && !bodySelected"
          class="zmdi zmdi-close"
        />
      </a>
      <!-- FOR EVENTUAL INCLUSION OF NOTE TITLES IF NEEDED <div
        @mouseover="titleHover = true"
        @mouseout="titleHover = false"
        >
            <h5
            v-show="!titleSelected"
            @click="selectTitle"
            >
                <strong>
                    {{note.attributes.title && note.attributes.title.length > 0 ? note.attributes.title : this.$t('Click here to add a title')}}
                    <i v-show="!titleSelected && titleHover" class="zmdi zmdi-edit c-gray" style="margin-left:5px;"></i>
                </strong>
            </h5>
            <input
            v-show="titleSelected"
            ref="title"
            type="text"
            v-model="note.attributes.title"
            @focusout="deSelectTitle"
            @keyup.enter="deSelectTitle"
            >
        </div> -->
      <div @mouseover="bodyHover = true" @mouseout="bodyHover = false">
        <div v-if="showAuthor && authorName" class="row">
          <!--<profile-info-card-->
          <!--:user-id="parseInt(note.author.identifier)"-->
          <!--:account-identifier="''"-->
          <!--&gt;-->
          <div class="col-md-3 col-xs-2">
            <img :src="authorPictureUrl" class="img-circle author-picture" />
          </div>
          <div class="col-md-9 col-xs-10 p-0">
            {{ authorName }}
          </div>
          <!--</profile-info-card>-->
        </div>
        <div class="row">
          <div class="col-md-12 col-md-offset-0 col-xs-8 col-xs-offset-2">
            <p
              ref="bodyParagraph"
              :class="{ offScreen: bodySelected }"
              class="m-b-0 p-5"
              @click="selectBody"
            >
              {{
                note.body && note.body.length > 0
                  ? note.body
                  : $t('Click here to add some text to the note')
              }}
              <i
                v-show="isEditable && !bodySelected && bodyHover"
                class="zmdi zmdi-edit c-gray tw-cursor-pointer"
                style="margin-left: 5px"
              />
            </p>
            <!-- eslint-disable vue/no-mutating-props &#45;&#45; Baseline eslint ignore please fix if working on this-->
            <textarea
              v-show="bodySelected"
              ref="body"
              v-model="note.body"
              class="form-control valid f-14 p-0 tw-mt-2"
              cols="50"
              @focusout="deSelectBody"
              @focus="adjustTextareaHeight"
              @keydown="adjustTextareaHeight"
              @keyup="adjustTextareaHeight"
              @keydown.delete="adjustTextareaLines"
              @keyup.delete="adjustTextareaLines"
            />
            <!-- eslint-enable-->
          </div>
        </div>
      </div>
      <div
        v-if="isDeletable && deleting"
        :class="{
          skeleton: loading,
        }"
        class="deleting-confirmation"
      >
        <div class="center">
          <div class="row">
            <div class="col-xs-7">
              <span>{{ $t('Delete this note?') }}</span>
            </div>
            <div class="col-xs-5">
              <a href="#" class="btn btn-xs btn-success c-white" @click="deleteThis">
                <i class="zmdi zmdi-delete" />
                {{ $t('Yes') }}
              </a>
              <a href="#" class="btn btn-xs btn-danger c-white" @click="deleting = false">
                <i class="zmdi zmdi-close" />
                {{ $t('No') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="m-t-5 m-b-5" />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { nextTick } from 'vue'
import enums from '@/utils/enum'
import { NetworkError } from '@/utils/notification'

export default {
  name: 'NotesAppNote',
  props: {
    note: {
      type: Object,
      required: true,
    },
    new: {
      type: Boolean,
      required: false,
    },
    showAuthor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      titleSelected: false,
      bodySelected: false,
      mouseHover: false,
      titleHover: false,
      bodyHover: false,
      deleting: false,
      editing: false,
      loadingValue: false,
    }
  },
  computed: {
    isEditable() {
      return this.note.viewerCanUpdate
    },
    loading: {
      get() {
        return this.loadingValue ?? false
      },
      set(val) {
        this.loadingValue = val
        this.$emit('loading', val)
      },
    },
    isDeletable() {
      return this.note.viewerCanDelete
    },
    authorName() {
      if (!this.note.author && !this.note.account) {
        return 'na'
      }
      return this.note.author ? this.note.author.name : this.note.account.name
    },
    authorPictureUrl() {
      if (!this.note.author && !this.note.account) {
        return 'na'
      }
      return this.note.author ? this.note.author.avatar : this.note.account.avatar
    },
  },
  watch: {
    editing() {
      this.$emit('edit', this.editing)
    },
  },
  async created() {
    if (this.new) {
      this.titleSelected = true
      this.selectTitle()
    }
  },
  methods: {
    selectTitle() {
      this.titleSelected = true
      this.editing = true
      nextTick(() => this.$refs.title.focus())
    },
    // eslint-disable-next-line consistent-return
    selectBody() {
      if (!this.isEditable) {
        return false
      }
      this.bodySelected = true
      this.editing = true
      nextTick(() => this.$refs.body.focus())
    },
    deSelectAll() {
      this.titleSelected = false
      this.bodySelected = false
      this.editing = false
      // Add save method
    },
    async updateNote() {
      return this.$apollo.mutate({
        mutation: gql`
          mutation updateNote($input: UpdateNoteInput!) {
            updateNote(input: $input) {
              id
              body
            }
          }
        `,
        client: 'publicApi',
        variables: {
          input: {
            id: this.note.id,
            title: this.note.title,
            body: this.note.body,
          },
        },
      })
    },
    async deSelectTitle() {
      this.deSelectAll()

      this.loading = true
      await this.updateNote()
      this.loading = false

      this.$emit('update', this.note)
    },
    async deSelectBody() {
      this.deSelectAll()
      try {
        this.loading = true
        await this.updateNote()
        this.loading = false
        this.$emit('update', this.note)
      } catch (e) {
        this.loading = false
        new NetworkError({
          msg: this.$t('Was not able to edit the note'),
          severity: enums.notification.severity.CRITICAL,
          ex: e,
        }).dispatch(this)
      }
    },
    async deleteThis() {
      // add delete method
      this.loading = true
      await this.$apollo.mutate({
        mutation: gql`
          mutation delete($input: DeleteNoteInput!) {
            deleteNote(input: $input) {
              id
            }
          }
        `,
        client: 'publicApi',
        variables: {
          input: {
            id: this.note.id,
          },
        },
      })
      this.loading = false
      this.$emit('deleted', this.note.id)
    },
    clickOutside(e) {
      this.deleting = false
      this.deSelectAll()
    },
    adjustTextareaHeight() {
      const el = this.$refs.body
      el.style.height =
        el.scrollHeight > el.clientHeight ? `${el.scrollHeight + 1}px` : el.style.height
    },
    adjustTextareaLines() {
      const el = this.$refs.body
      el.style.height = `${this.$refs.bodyParagraph.clientHeight + 1}px`
    },
  },
}
</script>

<style scoped lang="scss">
.note {
  position: relative;
}
.delete-button {
  position: absolute;
  top: 0px;
  right: 0px;
}
.offScreen {
  visibility: hidden !important;
  position: absolute !important;
  left: -99999999999 !important;
}
textarea {
  max-width: 100%;
  min-width: 100%;
  padding: 5px !important;
  overflow: hidden;
  word-wrap: break-word;
}
input {
  font-weight: bold;
  max-width: 100%;
  min-width: 100%;
}
h5 {
  max-width: 95%;
}
p {
  word-wrap: break-word;
  overflow: hidden;
  line-height: 1.42857143;
}
.center {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  text-align: center;
  transform: translateY(-50%);
}

.deleting-confirmation {
  background: #fcfcfc;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.author-picture {
  display: block;
  margin: 0 auto;
  width: 100%;
  min-width: 25px;
  max-width: 55px;
}
</style>
